import React from 'react';

import { usePollDays } from 'components/overview/Overview';

import PollPage from 'lib/PollPage/PollPage';
import { Pagesection, Teaser } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';

const CurrentPoll = () => {
  const { query: pollingDaysQuery } = usePollDays();
  const { t } = useTranslation('wap');

  const currentPoll = pollingDaysQuery.data?.data?.[0];

  return (
    <>
      <PollPage preventBreadcrumbUpdate id={currentPoll.id} headingLevel={2} />
      <Pagesection type="slender">
        <Teaser title={t('teaser_archive_title')} url="#/archiv" />
      </Pagesection>
    </>
  );
};

export default CurrentPoll;
